module.exports = __webpack_public_path__ + "static/media/PipetteRack.79f267f1.svg";